// services/uploadService.ts
import axios from "axios";
import { Upload } from "../types/features/Upload";
import { MAIN_API_URL, MAIN_URL } from "../config/api";

export const uploadService = {
    async uploadFile(
        { type, file, reason, user_id }: {
            type: 'image' | 'document' | 'video',
            file: File,
            reason?: string;
            user_id: string
        }
    ): Promise<Upload> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('type', type);
        formData.append('user_id', user_id);

        if (reason) formData.append('reason', reason);

        const response = await axios.post(`${MAIN_API_URL}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        const fullUrl = `${response.data.url}`;

        return {
            ...response.data,
            url: fullUrl
        };
    },

    async uploadMultiple(
        { files, reason, type, user_id }: {
            files: File[],
            type: 'image' | 'document' | 'video',
            reason?: string,
            user_id: string
        }
    ): Promise<Upload[]> {
        const promises = files.map(file => this.uploadFile({ type, file, reason, user_id }));
        return Promise.all(promises);
    },

    async deleteFile(url: string): Promise<void> {
        await axios.delete(`${MAIN_API_URL}/upload`, {
            data: { url }
        });
    }
};